<template>
  <div class="room-slider-modal" :class="{open: open}" @click="closeModal">
    <div class="room-slider-modal--backdrop"></div>
    <div class="room-slider-modal--content">
      <div class="slider-modal-header">
        <div class="room-name">{{roomName}}</div>
        <div class="action-close">
          <ModalCloseBtn @click="closeModal" :with-text="false"/>
        </div>
      </div>
      <div class="slider-modal-body">
        <div class="left-arrow arrow" v-on:click.stop="decrement" :style="{opacity: leftEnable ? 1 : 0}">
          <i class="la la-caret-left"></i>
        </div>
        <div class="main-content-container" v-on:click.stop="">
          <div class="preview" :style="computedStyle"></div>
        </div>
        <div class="right-arrow arrow" v-on:click.stop="increment" :style="{opacity: rightEnable ? 1 : 0}">
          <i class="la la-caret-right"></i>
        </div>
      </div>
      <div class="slider-modal-footer">
        <div class="footer-wrapper with-scrollbar wide" ref="scroll">
          <div v-for="(item, i) in pictures" :index="i" :key="item.src"
               class="smf-item"
               v-on:click.stop="setIndex(i)"
               :class="{active: index === i}"
               :style="{
              backgroundImage: `url('${cdnPath(item.src, {w: item.ratio * 119, h: 119, q:40})}')`,
              width: (item.ratio * 119) + 'px',
              height: '119px',
            }"
          >
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ModalCloseBtn from "../../../components/modal-close-btn";
import {cdnPath} from "../../../helpers/cdn-helper";

export default {
  name: "RpModal",
  components: {ModalCloseBtn},
  data() {
    return {
      cdnPath: cdnPath
    }
  },
  computed: {
    ...mapState({
      open: s => s.room.modalSlider,
      pictures: s => s.room.modalSliderPictures,
      index: s => s.room.currentModalSliderIndex,
      roomName: s => s.room.room.text.short_name,
      rightEnable: s => (s.room.currentModalSliderIndex !== s.room.modalSliderPictures.length - 1),
      leftEnable: s => (s.room.currentModalSliderIndex !== 0),
      computedStyle: s => {
        if (s.room.modalSliderPictures[s.room.currentModalSliderIndex]) {
          return {
            backgroundImage: `url('${cdnPath(s.room.modalSliderPictures[s.room.currentModalSliderIndex].src)}')`
          };
        }
        return null;
      }
    })
  },
  watch: {
    open (v) {
      this.handleBodyClass();
    },
    index (v) {
      this.handleIndexChange();
    }
  },
  mounted () {
    this.handleBodyClass();
    this.handleIndexChange();
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onKeyDown (e) {
      if (e.code === 'ArrowRight') return this.increment();
      if (e.code === 'ArrowLeft') return this.decrement();
    },
    handleIndexChange () {
      this.$nextTick(() => {
        const scroll = this.$refs.scroll;
        if (!scroll) return;
        const active = scroll.querySelector('.active');
        if (!active) return;
        scroll.scrollLeft = active.offsetLeft - (scroll.clientWidth / 2) + (active.clientWidth / 2);
      })
    },
    decrement () {
      this.$store.commit('room/SET_MODAL_SLIDER_INDEX', Math.max(0, this.index - 1));
    },
    increment () {
      this.$store.commit('room/SET_MODAL_SLIDER_INDEX', Math.min(this.index + 1, this.pictures.length - 1));
    },
    setIndex (i) {
      this.$store.commit('room/SET_MODAL_SLIDER_INDEX', i);
    },
    handleBodyClass () {
      if (this.open) {
        document.body.classList.add('noslide')
      } else {
        document.body.classList.remove('noslide');
      }
    },
    closeModal () {
      this.$store.commit('room/SET_MODAL_SLIDER', false);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/rooms/components/RpModal.vue